import { TextField, Typography, Button } from "@mui/material";
import { useState } from "react";
import { maskCnpj } from "utils/Masks/Masks";
import ClientIndustrial from "assets/client-industrial.png";
import { useConsigazApi } from "hooks/useConsigazApi";
import { toast } from "react-toastify";

export default function Cnpj({ onSuccess }) {
  const [cnpj, setCnpj] = useState("");

  const api = useConsigazApi();

  const handleSubmit = async () => {
    if (!cnpj) {
      return toast.error("Por favor, informe o CNPJ.");
    }

    const normalizedCpfCnpj = cnpj.replace(/[^0-9A-Za-z]/g, "").toUpperCase();

    try {
      const response = await api.consultCpfCnpj(normalizedCpfCnpj);

      if (response.RetornoUsuario[0]["tipo-conta"] === "INDUSTRIAL") {
        return onSuccess(normalizedCpfCnpj);
      }
      return toast.error("CNPJ informado sem conta industrial cadastrada");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <img src={ClientIndustrial} />
      <Typography
        color="#FFFFFF"
        fontWeight={700}
        fontSize={"30px"}
        mt={"30px"}
      >
        Vincular nova conta industrial
      </Typography>
      <Typography
        color="#FFFFFF"
        fontSize={"15px"}
        mt={"10px"}
        textAlign={"justify"}
      >
        Para criar um novo vínculo de acesso, favor informar o CNPJ para a nova
        conta industrial a ser criado o acesso.
      </Typography>

      <TextField
        variant="standard"
        color="secondary"
        value={cnpj}
        fullWidth
        onChange={(e) => {
          const cnpjMasked = maskCnpj(e.target.value);
          setCnpj(cnpjMasked);
        }}
        placeholder={"CNPJ"}
        sx={{
          mt: 5,
          "& input::-webkit-inner-spin-button": {
            WebkitAppearance: "none",
          },
        }}
      />
      <Button
        variant="contained"
        color="secondary"
        sx={{
          height: "45px",
          color: "#fff",
          borderRadius: "36px",
          width: "100%",
          mt: 2,
        }}
        onClick={handleSubmit}
      >
        Avançar
      </Button>
    </>
  );
}
